import React from "react";
import {  useSelector } from "react-redux";
import useSearchItem from "../../hooks/useSearchItem";
import { SETISSHOWWEBSEARCH } from "../../redux/features/common";
import useAppDispatch from "../../hooks/useAppDispatch";
import useReduxData from "../../hooks/useReduxData";
const HeaderSearch = () => {
  const dispatch=useAppDispatch()
  const redux_data = useReduxData();
  const { isShowWebSearch } = redux_data.commonData;
  const {
    filterData: { search },
  }: any = useSelector((state: any) => state);
  const {handleSearch} = useSearchItem();

    const updateShowMobileSearch = (val: any) => {
      dispatch(SETISSHOWWEBSEARCH(val));
    };
  

  return (
    <>
      <div
        className={`flex justify-between  gap-2 py-[2px] transition-all md:max-w-96
    ${
      isShowWebSearch ? "w-full pr-2 md:pr-0" : "w-10 xl:w-full"
    } mobile-map-hide`}
      >
        <div className="flex textMd bg-[#f1f1f1] text-[#6A6A6A] rounded-[.5rem] items-center justify-center border-mercury-ui-divider  w-full flex-1 transition-all">
          <div className="flex relative w-full items-center">
            {!isShowWebSearch && (
              <div className="flex" onClick={() => updateShowMobileSearch(true)}>
                <button
                  className="flex rounded-mercury-ui-control  text-left transition bg-none text-mercury-ui-secondary hover:text-mercury-ui-primary hover:ring-mercury-ui-text-primary/20 hover:ring-3 group my-px xl:my-0 border-mercury-ui-divider h-9 w-9 items-center justify-center focus:outline-hidden"
                  title="Search"
                >
                  <span className="text-mercury-ui-button-base font-mercury-ui-primary block overflow-hidden text-ellipsis whitespace-nowrap">
                    <svg
                      data-v-1926ed76=""
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      height="16"
                      width="16"
                      role="img"
                      className="streamline-ico"
                    >
                      <path
                        d="M16.221 16.22L23.25 23.25"
                        fill="none"
                        stroke="#000000"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                      ></path>
                      <path
                        d="M0.750 9.812 A9.063 9.063 0 1 0 18.876 9.812 A9.063 9.063 0 1 0 0.750 9.812 Z"
                        fill="none"
                        stroke="#000000"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        transform="translate(-3.056 4.62) rotate(-23.025)"
                      ></path>
                    </svg>
                  </span>
                </button>
              </div>
            )}
            {isShowWebSearch && (
              <div
                className={`relative h-10 !w-[28rem] items-center gap-x-3 md:h-9 search-items-input ${
                  isShowWebSearch ? "" : ""
                }`}
                data-testid="search-input-container"
              >
                <div
                  className={`search-btn-icon flex absolute top-1/2 left-4 -translate-y-1/2 cursor-pointer lg:block `}
                >
                  <svg
                    data-v-1926ed76=""
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    height="16"
                    width="16"
                    role="img"
                    className="streamline-ico"
                  >
                    <path
                      d="M16.221 16.22L23.25 23.25"
                      fill="none"
                      stroke="#000000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    ></path>
                    <path
                      d="M0.750 9.812 A9.063 9.063 0 1 0 18.876 9.812 A9.063 9.063 0 1 0 0.750 9.812 Z"
                      fill="none"
                      stroke="#000000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      transform="translate(-3.056 4.62) rotate(-23.025)"
                    ></path>
                  </svg>
                </div>
                <div className="flex h-full flex-1">
                  <input
                    className="flex w-full border-none bg-transparent p-0 pl-10"
                    placeholder="Search for the dish"
                    aria-label="Search"
                    type="text"
                    value={search}
                    onChange={(e) => handleSearch(e.target.value)}
                  />
                  {isShowWebSearch && (
                    <button
                      className="py-2 px-2"
                      title="Clear search"
                      onClick={() => {
                        handleSearch("");
                        updateShowMobileSearch(false);
                      }}
                    >
                      <svg
                        data-v-256125a6=""
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        height="14"
                        width="14"
                      >
                        <path
                          d="M23.25 23.249L0.75 0.749"
                          fill="none"
                          stroke="#000"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.5"
                        ></path>
                        <path
                          d="M0.75 23.249L23.25 0.749"
                          fill="none"
                          stroke="#000"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.5"
                        ></path>
                      </svg>
                    </button>
                  )}
                </div>
                {/* {isShowWebSearch && (
                  <button
                    className="font-mercury-ui-primary text-mercury-ui-button-base text-mercury-ui-button-tertiary px-2 cancle-search"
                    title="Cancel Search"
                    onClick={() => updateShowMobileSearch(false)}
                  >
                    <svg
                      data-v-256125a6=""
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      height="20"
                      width="20"
                      role="img"
                      className="streamline-ico"
                    >
                      <path
                        d="M23.25 23.249L0.75 0.749"
                        fill="none"
                        stroke="#000"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                      ></path>
                      <path
                        d="M0.75 23.249L23.25 0.749"
                        fill="none"
                        stroke="#000"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                      ></path>
                    </svg>
                  </button>
                )} */}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderSearch;
